// extracted by mini-css-extract-plugin
export default {"root":"ColorPicker_root__u3iPz","picker":"ColorPicker_picker__XizsB","preview":"ColorPicker_preview__hi5lP"};